export default "__VITE_ASSET__D$GRp8k$__"